import React from 'react';

type TextBlockProps = {
  text: string;
  color: string;
  slug?: string;
};

const getUrl = () => {
  if (window.zola.env === 'production') {
    return 'https://www.zola.com';
  }
  if (window.zola.env === 'staging') {
    return 'https://qa.zola.com';
  }
  return 'http://localhost';
};

const emailSpacer = (size: number) => {
  const sizeStr = `${size}px`;
  return (
    <table
      cellPadding="0"
      cellSpacing="0"
      // @ts-ignore
      border="0"
      width="100%"
      style={{ borderCollapse: 'collapse', width: '100%' }}
    >
      <tbody>
        <tr>
          <td height={sizeStr} style={{ fontSize: sizeStr, lineHeight: sizeStr }}>
            &#xA0;
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const DSTDImage = ({ bgColor }: any): JSX.Element => {
  return (
    <table
      // @ts-ignore
      bgcolor={`#${bgColor}40`}
      cellPadding="0"
      cellSpacing="0"
      // @ts-ignore
      border="0"
      width="600"
      style={{ borderCollapse: 'collapse', width: '100%', backgroundColor: `#${bgColor}40` }}
      align="center"
    >
      <tbody>
        <tr>
          <td align="center" style={{ width: '100%' }}>
            <table
              cellPadding="0"
              cellSpacing="0"
              // @ts-ignore
              border="0"
              style={{ borderCollapse: 'collapse', width: '80%' }}
              align="center"
            >
              <tbody>
                <tr>
                  <td align="center">
                    <img
                      width="600"
                      style={{ display: 'block', width: '100%', height: 'auto', maxWidth: '600px' }}
                      src="https://stage-images.zola.com/6e98f3fb-34bc-4283-9d7c-bf11d30a6488"
                      alt="Zola - Digital Save the Date"
                      // @ts-ignore
                      vspace="60"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const IntroBlock = ({ color, text }: TextBlockProps): JSX.Element => {
  return (
    <>
      <h1
        style={{
          margin: 0,
          padding: 0,
          textAlign: 'center',
          color: `#${color}`,
          whiteSpace: 'pre-wrap',
        }}
      >
        {text}
      </h1>
    </>
  );
};

const WebsiteBlock = ({ text, slug, color }: TextBlockProps): JSX.Element => {
  return (
    <>
      <p
        style={{
          margin: 0,
          padding: 0,
          textAlign: 'center',
          color: `#${color}`,
          lineHeight: 1.3,
          whiteSpace: 'pre-wrap',
        }}
      >
        {text}
        <br />
        <br />
      </p>
      <a href={`${getUrl()}/wedding/${slug}`} style={{ display: 'block', textAlign: 'center' }}>
        Wedding Website
      </a>
    </>
  );
};

const SuperLinkBlock = ({ text, slug, color }: TextBlockProps): JSX.Element => {
  return (
    <>
      <p
        style={{
          margin: 0,
          padding: 0,
          textAlign: 'center',
          color: `#${color}`,
          lineHeight: 1.3,
          whiteSpace: 'pre-wrap',
        }}
      >
        {text}
        <br />
        <br />
      </p>

      <a href={`${getUrl()}/addr/${slug}`} style={{ display: 'block', textAlign: 'center' }}>
        Give Your Info
      </a>
    </>
  );
};

const DSTDEmailTemplate = React.forwardRef((props: any, ref) => {
  const bodyBgColor = 'ffffff';

  // @ts-ignore
  const { bgColor, customizationData } = props;
  const {
    titleData: { text: titleText, color: titleColor },
    dstdSlug,
    websiteData,
    superLinkData,
  } = customizationData;

  const titleComponent = <IntroBlock text={titleText} color={titleColor} />;
  const dstdLinkComponent = (
    <div>
      <a href={`${getUrl()}/wedding-planning/digital-save-the-date/${dstdSlug}`}>
        View our Save the Date!
      </a>
    </div>
  );

  let websiteComponent = null;
  let superLinkComponent = null;

  if (websiteData) {
    const { text, slug, color } = websiteData;
    websiteComponent = <WebsiteBlock text={text} slug={slug} color={color} />;
  }

  if (superLinkData) {
    const { text, slug, color } = superLinkData;
    superLinkComponent = <SuperLinkBlock text={text} slug={slug} color={color} />;
  }

  return (
    // @ts-ignore
    <div ref={ref} id="dynamic-email-template" style={{ position: 'absolute', left: '-10000px' }}>
      <div style={{ minWidth: '100%', width: '100%' }}>
        <table
          cellPadding="0"
          cellSpacing="0"
          // @ts-ignore
          border="0"
          width="100%"
          style={{ minWidth: '100%', width: '100% !important', backgroundColor: `#${bodyBgColor}` }}
          align="center"
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  width="100%"
                  style={{ height: '100%', width: '100% !important' }}
                  cellPadding="0"
                  cellSpacing="0"
                  // @ts-ignore
                  border="0"
                  align="center"
                >
                  <tbody>
                    <tr>
                      <td align="center">
                        {/* @ts-ignore */}
                        <center>
                          <table
                            width="100%"
                            style={{ width: '100%' }}
                            cellPadding="0"
                            cellSpacing="0"
                            // @ts-ignore
                            border="0"
                            align="center"
                          >
                            <tbody>
                              <tr>
                                <td align="center">
                                  <table
                                    width="100%"
                                    style={{ width: '100%' }}
                                    cellPadding="0"
                                    cellSpacing="0"
                                    // @ts-ignore
                                    border="0"
                                    align="center"
                                  >
                                    <tbody>
                                      <tr>
                                        <td align="center">
                                          <DSTDImage bgColor={bgColor} />
                                          {emailSpacer(20)}
                                          <table
                                            cellPadding="0"
                                            cellSpacing="0"
                                            // @ts-ignore
                                            border="0"
                                            width="600"
                                            style={{ width: '100%', maxWidth: '600px' }}
                                            align="center"
                                          >
                                            <tbody>
                                              <tr>
                                                <td align="center">
                                                  {titleComponent}
                                                  {emailSpacer(20)}
                                                  {dstdLinkComponent}
                                                  {emailSpacer(20)}
                                                  {superLinkComponent}
                                                  {emailSpacer(20)}
                                                  {websiteComponent}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {/* @ts-ignore */}
                        </center>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td>
                <div
                  style={{
                    display: 'none',
                    whiteSpace: 'nowrap',
                    font: '15px courier',
                    lineHeight: '0',
                  }}
                >
                  {' '}
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{' '}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default DSTDEmailTemplate;
